import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './style.css';

class LibraryDeleteModal extends React.Component {
  render() {
    const {
      onHide,
      showDeleteModal,
      disableHideOnOuterModal,
      title,
      name,
      onDelete,
      isSubmittingForm,
    } = this.props;

    return (
      <Modal
        onHide={
          disableHideOnOuterModal
            ? function() {
                /* no op */
              }
            : onHide
        }
        show={showDeleteModal}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header id={styles['header-delete']}>
          <button
            onClick={onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Modal.Title className={styles['title-modal']}>
            Delete {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure want to delete <b>{name}</b> ? this action cannot be
            undone
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button type="button" className="btn btn-default" onClick={onHide}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onDelete}
              disabled={isSubmittingForm}
            >
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

LibraryDeleteModal.propTypes = {
  onHide: PropTypes.func,
  disableHideOnOuterModal: PropTypes.bool,
  showDeleteModal: PropTypes.bool,
  title: PropTypes.string,
  name: PropTypes.string,
  onDelete: PropTypes.func,
};

export default LibraryDeleteModal;
